import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import hamburger from './hamburger.svg';
class PrimaryNav extends Component {

    constructor(props){
        super(props);
        this.state = {
            mobileNavOn: false
        }
        this.showMobileNav = this.showMobileNav.bind(this);
        this.hideMobileNav = this.hideMobileNav.bind(this);
        this.menuClass = this.menuClass.bind(this);
    }

    showMobileNav = () => {
        this.setState({
            mobileNavOn: true
        });
    };

    hideMobileNav = () => {
        this.setState({
            mobileNavOn: false
        });
    };

    transparency = () => {
        if(this.props.transparent === 'true'){
            return "transparent";
        } else {
            return "";
        }
    };

    menuClass = () => {
        const otherClasses = " primary-nav-mobile col-sm-12 col-md-8 override-position-mobile";

        if (this.state.mobileNavOn) {
            return "mobile-nav-on" + otherClasses
        } else {
            return "mobile-nav-off" + otherClasses;
        }
    };

  render() {

    return (

        <div className={"primary-nav-outer " + this.transparency()}>
            <div className="container primary-nav override-position-mobile">
                <div className="row">
                    <div className="hidden-sm col-md-4">
                        <h1>{this.props.title}</h1>
                    </div>
                    <button onClick={() => this.showMobileNav()} className="hidden-sm hidden-md hidden-lg mobile-nav-trigger"><img src={hamburger} alt=""/><span className="sr-only">expand main menu</span></button>
                    <div className={this.menuClass()}>
                        <div className="hidden-sm hidden-md hidden-lg mobile-menu-header">
                            <span className="mobile-menu-title">Menu</span>
                            <button onClick={() => this.hideMobileNav()} className="mobile-menu-close" id="mobile-menu-close">X</button>
                        </div>
                        <nav aria-label="mobile navigation">
                            <ul className="primary-nav-list list-inline">
                                <li><NavLink exact activeClassName="active" to="/">Home</NavLink></li>
                                <li><NavLink activeClassName="active" to="/services/tradeshow_management">Tradeshow Management</NavLink></li>
                                <li><NavLink activeClassName="active" to="/services/exhibit_management">Exhibit Management</NavLink></li>
                                <li><NavLink activeClassName="active" to="/displays/displays">Displays</NavLink></li>
                                <li><NavLink activeClassName="active" to="/displays/custom_fabrication">Custom Fabrication</NavLink></li>
                                <li><NavLink activeClassName="active" to="/accessories">Accessories</NavLink></li>
                                <li><NavLink activeClassName="active" to="/design">Design</NavLink></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="primary-nav-desktop hidden-xs col-sm-12 col-md-8">
                        <div className="hidden-sm hidden-md hidden-lg mobile-menu-header">
                            <span className="mobile-menu-title">Menu</span>
                            <button onClick={() => this.hideMobileNav()} className="mobile-menu-close" id="mobile-menu-close">X</button>
                        </div>
                        <nav aria-label="main navigation">
                            <ul className="primary-nav-list list-inline">
                                <li><NavLink exact activeClassName="active" to="/">Home</NavLink></li>
                                <li><NavLink activeClassName="active" to="/services/tradeshow_management">Services</NavLink></li>
                                <li><NavLink activeClassName="active" to="/displays/displays">Displays</NavLink></li>
                                <li><NavLink activeClassName="active" to="/accessories">Accessories</NavLink></li>
                                <li><NavLink activeClassName="active" to="/design">Design</NavLink></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default PrimaryNav;



// WEBPACK FOOTER //
// ./src/components/PrimaryNav/PrimaryNav.js